import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import { postNotification } from 'ReduxMessenger/actions/NotificationActions';
import Raven from 'raven-js';
import ErrorActionAlertBody from 'conversations-error-reporting/error-actions/components/ErrorActionAlertBody';
import { getErrorTitle, isSilent, isErrorReoprtingSilenced } from 'conversations-error-reporting/error-actions/operators/errorActionGetters';
import { isErrorAction } from 'conversations-error-reporting/error-actions/operators/isErrorAction';
import { captureActionBreadcrumb } from 'conversations-error-reporting/error-reporting/captureActionBreadcrumb';
import { reportErrorAction } from 'conversations-error-reporting/error-reporting/reportErrorAction';
import { jsx as _jsx } from "react/jsx-runtime";
const FAILED_ACTION = 'FAILED_ACTION';
const NOT_REPORTED = 'NOT_REPORTED';
function captureNonActionBreadcrumb(action) {
  try {
    Raven.captureBreadcrumb({
      message: `type: ${typeof action}, toString: "${action}", JSON.stringify: "${JSON.stringify(action)}"`,
      category: 'not redux action'
    });
  } catch (e) {
    // it's fine if this fails
  }
}
export const inboxErrorMiddleware = store => next => action => {
  captureActionBreadcrumb(action);
  if (!action.type) {
    captureNonActionBreadcrumb(action);
  }
  if (isErrorAction(action)) {
    const eventId = isErrorReoprtingSilenced(action) ? NOT_REPORTED : reportErrorAction(action);
    if (!isSilent(action) && window.navigator.onLine) {
      const defaultText = I18n.text('conversations-inbox-ui.errorAlert.titleText');
      const notification = {
        id: FAILED_ACTION,
        titleText: getErrorTitle(action) || defaultText,
        message: /*#__PURE__*/_jsx(ErrorActionAlertBody, {
          action: action,
          eventId: eventId
        }),
        type: 'danger'
      };
      store.dispatch(postNotification(notification));
    }
  }
  return next(action);
};